<template>
<div>
    <div v-if="ie=='i'">
        <!-- 巴基斯坦(PAK)进口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">进口商税务号</th>
                        <td width="25%">{{billInfo.ImporterId}}</td>
                        <th width="25%">数量单位</th>
                        <td width="25%">{{billInfo.Unit}}</td>
                    </tr>
                    <tr>
                        <th>单价</th>
                        <td>{{billInfo.UnitValue}} {{billInfo.UnitValueCurrency}}</td>
                        <th>总价</th>
                        <td>{{billInfo.Value}} {{billInfo.Currency}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>

        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">运输信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th width="25%">港口代码</th>
                        <td width="25%">{{billInfo.PortCode}}</td>
                        <th width="25%">来源国</th>
                        <td width="25%">{{billInfo.Country}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>

        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">计税信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th width="25%">币种代码</th>
                        <td width="25%">{{billInfo.CurrencyCode}}</td>
                        <th width="25%">指定税率</th>
                        <td width="25%">{{billInfo.AssignedRate}}</td>
                    </tr>
                    <tr>
                        <th>公布税率</th>
                        <td>{{billInfo.DeclaredRate}}</td>
                        <th>关税</th>
                        <td>{{billInfo.CustomsDuty}}</td>
                    </tr>
                    <tr>
                        <th>销售税</th>
                        <td>{{billInfo.SalesTax}}</td>
                        <th>附加销售税</th>
                        <td>{{billInfo.AdditionalSalesTax}}</td>
                    </tr>
                    <tr>
                        <th>所得税</th>
                        <td>{{billInfo.IncomeTax}}</td>
                        <th>其他税</th>
                        <td>{{billInfo.OtherTaxes}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>

        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">其他信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th width="25%">Igm号</th>
                        <td width="25%">{{billInfo.IgmNo}}</td>
                        <th width="25%">文件名</th>
                        <td width="25%">{{billInfo.FileNames}}</td>
                    </tr>
                    <tr>
                        <th>SRO</th>
                        <td>{{billInfo.SRO}}</td>
                        <th>CRN</th>
                        <td>{{billInfo.CRN}}</td>
                    </tr>
                    <tr>
                        <th>Number</th>
                        <td>{{billInfo.Number}}</td>
                        <th>PCT</th>
                        <td>{{billInfo.PCT}}</td>
                    </tr>
                    <tr>
                        <th>DV</th>
                        <td>{{billInfo.DV}}</td>
                        <th>AV</th>
                        <td>{{billInfo.AV}}</td>
                    </tr>
                    <tr>
                        <th>网站</th>
                        <td>{{billInfo.Website}}</td>
                        <th>评估价值</th>
                        <td>{{billInfo.AssessValue}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
    <div v-if="ie=='e'">
        <!-- 巴基斯坦(PAK)出口提单明细 -->
        <el-card class="partItem">
            <table>
                <tbody>
                    <tr>
                        <th width="25%">出口商税务号</th>
                        <td width="25%">{{billInfo.ExporterId}}</td>
                        <th width="25%">数量单位</th>
                        <td width="25%">{{billInfo.Unit}}</td>
                    </tr>
                    <tr>
                        <th>单价</th>
                        <td>{{billInfo.UnitPrice}}</td>
                        <th>总价</th>
                        <td>{{billInfo.Value}}</td>
                    </tr>
                    <tr>
                        <th>卢比总价</th>
                        <td>{{billInfo.TotalValueInPK}}</td>
                        <th>币种代码</th>
                        <td>{{billInfo.Currency}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>

        <el-card class="partItem">
            <div slot="header">
                <span class="headTitle">运输信息</span>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th width="25%">装运港</th>
                        <td width="25%">{{billInfo.ShipmentPort}}</td>
                        <th width="25%">目的国</th>
                        <td width="25%">{{billInfo.Country}}</td>
                    </tr>
                    <tr>
                        <th>文件名</th>
                        <td>{{billInfo.FileName}}</td>
                        <th>代理公司</th>
                        <td>{{billInfo.AgentName}}</td>
                    </tr>
                </tbody>
            </table>
        </el-card>
    </div>
</div>
</template>

<script>
export default {
    props:["billInfo","ie"],
    data() {
        return {

        };
    },
    methods: {
        
    },
    mounted() {

    },
};
</script>

<style lang="scss" scoped>
.partItem {
    margin-bottom: 20px;
    ::v-deep .el-card__header {
        padding: 10px 20px;
        .headTitle {
            display: inline-block;
            padding-left: 10px;
            font-size: 14px;
            border-left: 2px solid var(--themeColor);
            font-weight: bold;
        }
    }
}
table {
    width: 100%;
    border-collapse: collapse;
    tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
        th,
        td {
            font-size: 12px;
            color: #666;
            height: 40px;
            border: 1px solid #eaeaea;
            text-align: center;
        }
        th {
            background-color: #f5f7fa;
            font-weight: 700;
        }
        .bg {
            background-color: var(--themeColor);
            color: #fff;
            font-weight: 700;
            opacity: 0.8;
        }
    }
}
</style>